(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.SilkCraneSending = api;
})(typeof window === 'undefined' ? globalThis : window, function () {
  'use strict';
  const VERSION = '1.0.0';
  const TTL = 24 * 60 * 60 * 1000;
  const PACKAGES = ['carry_on', 'large_suitcase', 'ski_snowboard', 'golf', 'bicycle', 'family_luggage', 'family_sports_ski_snowboard', 'family_sports_golf'];
  const BRANCHES = {
    hotel: ['location_name', 'address', 'contact_phone', 'sending_date'],
    private_residence: ['pickup_assistance', 'address', 'contact_name', 'contact_phone', 'sending_date'],
    drop_off: ['sending_point_kind', 'location_name', 'sending_date'],
    airport: ['location_name', 'terminal', 'sending_date'],
    undecided: []
  };
  const FIELD_TYPES = { location_name: 'short_text', address: 'multiline_text', contact_name: 'short_text', contact_phone: 'short_text', terminal: 'short_text', sending_date: 'date', pickup_assistance: 'choice', sending_point_kind: 'choice', notes: 'multiline_text' };
  const LIMITS = { location_name: 120, address: 500, contact_name: 120, contact_phone: 40, terminal: 120, notes: 1000 };
  const CHOICES = { pickup_assistance: ['requested', 'not_requested', 'undecided'], sending_point_kind: ['convenience_store', 'yamato_center', 'undecided'] };
  const PROPERTY_FIELDS = { location_name: 'Sending location', address: 'Sending address', terminal: 'Sending terminal', contact_name: 'Sending contact name', contact_phone: 'Sending contact phone', sending_date: 'Sending date', notes: 'Sending notes' };
  const META_PROPERTIES = ['_sc_sending_format_version', '_sc_sending_controller_version', '_sc_sending_form_key', '_sc_sending_content_revision', '_sc_sending_situation_key', 'Sending situation'];
  const ALL_PROPERTIES = [...META_PROPERTIES, ...Object.values(PROPERTY_FIELDS), '_sc_sending_point_kind', 'Sending point', '_sc_sending_date_kind', '_sc_pickup_assistance', 'Pickup assistance'];
  const object = (x) => x !== null && typeof x === 'object' && !Array.isArray(x);
  function check(condition, code = 'SENDING_CONFIG_INVALID') {
    if (!condition) { const error = new Error(code); error.code = code; throw error; }
  }
  function exact(x, keys) {
    check(object(x) && Object.keys(x).length === keys.length && keys.every((k) => Object.hasOwn(x, k)));
  }
  function text(x, max = 1000, empty = false) { check(typeof x === 'string' && x.length <= max && (empty || x.trim().length > 0)); }
  function list(x, allowed, complete = false) {
    check(Array.isArray(x) && new Set(x).size === x.length && x.every((k) => allowed.includes(k)) && (!complete || x.length === allowed.length));
  }
  function field(f) {
    exact(f, ['schema_version', 'field_key', 'label', 'help_text', 'example', 'input_kind', 'max_length', 'choices', 'pickup_label']);
    check(f.schema_version === 1 && Object.hasOwn(FIELD_TYPES, f.field_key) && f.input_kind === FIELD_TYPES[f.field_key]);
    text(f.label, 120); text(f.help_text, 1000, true); text(f.example, 1000, true); text(f.pickup_label, 120, true);
    check(f.field_key === 'sending_date' || f.pickup_label === '');
    if (Object.hasOwn(LIMITS, f.field_key)) check(Number.isInteger(f.max_length) && f.max_length > 0 && f.max_length <= LIMITS[f.field_key]);
    else check(f.max_length === null);
    check(Array.isArray(f.choices));
    if (!Object.hasOwn(CHOICES, f.field_key)) check(f.choices.length === 0);
    else {
      list(f.choices.map((c) => c.choice_key), CHOICES[f.field_key], true);
      f.choices.forEach((c) => {
        exact(c, ['schema_version', 'choice_key', 'label', 'help_text', 'allowed_package_keys']);
        check(c.schema_version === 1); text(c.label, 120); text(c.help_text, 1000, true);
        list(c.allowed_package_keys, PACKAGES); check(c.allowed_package_keys.length > 0);
        if (c.choice_key === 'convenience_store') check(!c.allowed_package_keys.includes('ski_snowboard') && !c.allowed_package_keys.includes('family_sports_ski_snowboard'));
        else list(c.allowed_package_keys, PACKAGES, true);
      });
    }
  }
  function validateForm(form, base = { schema_version: 6, customizer_version: '0.7.0' }) {
    check(base.schema_version === 6 && base.customizer_version === '0.7.0', 'SENDING_BASE_VERSION');
    exact(form, ['schema_version', 'form_key', 'format_version', 'content_revision', 'heading_luggage', 'heading_sports', 'choice_heading', 'change_label', 'help_text', 'pickup_request_message', 'situations', 'notes_field']);
    check(form.schema_version === 1 && form.format_version === 1 && Number.isSafeInteger(form.content_revision) && form.content_revision > 0);
    check(typeof form.form_key === 'string' && /^[a-z][a-z0-9_]{0,119}$/.test(form.form_key));
    text(form.choice_heading, 120); text(form.change_label, 120); text(form.heading_luggage, 120); text(form.heading_sports, 120); text(form.help_text); text(form.pickup_request_message);
    check(Array.isArray(form.situations)); list(form.situations.map((s) => s.situation_key), Object.keys(BRANCHES), true);
    form.situations.forEach((s) => {
      exact(s, ['schema_version', 'situation_key', 'label', 'help_text', 'fields', 'required_field_keys', 'allowed_package_keys']);
      check(s.schema_version === 1); text(s.label, 120); text(s.help_text, 1000, true);
      list(s.allowed_package_keys, PACKAGES, true);
      check(Array.isArray(s.fields)); list(s.fields.map((f) => f.field_key), BRANCHES[s.situation_key], true);
      const required = s.situation_key === 'private_residence' ? ['pickup_assistance'] : s.situation_key === 'drop_off' ? ['sending_point_kind'] : [];
      list(s.required_field_keys, required, true); s.fields.forEach(field);
    });
    field(form.notes_field); check(form.notes_field.field_key === 'notes');
    return form;
  }
  function emptyAnswers() { return { situation_key: '', values: {} }; }
  function clean(value) { return typeof value === 'string' ? value.replace(/\r\n?/g, '\n').trim() : value; }
  function dateValid(s) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return false;
    const [y, m, d] = s.split('-').map(Number);
    if (y < 1900 || y > 9999 || m < 1 || m > 12 || d < 1) return false;
    return d <= new Date(Date.UTC(y, m, 0)).getUTCDate();
  }
  function validateAnswers(form, answers, packageKey, partial = false) {
    validateForm(form); check(PACKAGES.includes(packageKey), 'SENDING_PACKAGE');
    exact(answers, ['situation_key', 'values']); check(object(answers.values), 'SENDING_ANSWER_INVALID');
    if (partial && answers.situation_key === '') { check(Object.keys(answers.values).length === 0); return emptyAnswers(); }
    const situation = form.situations.find((s) => s.situation_key === answers.situation_key);
    check(situation && situation.allowed_package_keys.includes(packageKey), 'SENDING_SITUATION_REQUIRED');
    const fields = [...situation.fields, form.notes_field];
    check(Object.keys(answers.values).every((k) => fields.some((f) => f.field_key === k)), 'SENDING_INACTIVE_FIELD');
    const values = {};
    fields.forEach((f) => {
      const value = Object.hasOwn(answers.values, f.field_key) ? clean(answers.values[f.field_key]) : '';
      check(typeof value === 'string', 'SENDING_ANSWER_INVALID');
      if (!partial && situation.required_field_keys.includes(f.field_key)) check(value !== '', 'SENDING_CHOICE_REQUIRED');
      if (value === '') return;
      if (f.input_kind === 'choice') check(f.choices.some((c) => c.choice_key === value && c.allowed_package_keys.includes(packageKey)), 'SENDING_CHOICE_INVALID');
      else if (f.input_kind === 'date') check(dateValid(value), 'SENDING_DATE_INVALID');
      else check(value.length <= f.max_length, 'SENDING_TEXT_TOO_LONG');
      values[f.field_key] = value;
    });
    return { situation_key: situation.situation_key, values };
  }
  function compatibleAnswers(form, answers, packageKey) {
    const s = form.situations.find((x) => x.situation_key === answers.situation_key);
    if (!s || !s.allowed_package_keys.includes(packageKey)) return emptyAnswers();
    const values = {};
    [...s.fields, form.notes_field].forEach((f) => {
      const value = answers.values[f.field_key];
      if (typeof value !== 'string') return;
      if (f.input_kind !== 'choice' || value === '' || f.choices.some((c) => c.choice_key === value && c.allowed_package_keys.includes(packageKey))) values[f.field_key] = value;
    });
    return { situation_key: s.situation_key, values };
  }
  function properties(form, answers, packageKey) {
    const a = validateAnswers(form, answers, packageKey);
    const s = form.situations.find((x) => x.situation_key === a.situation_key);
    const p = { _sc_sending_format_version: '1', _sc_sending_controller_version: VERSION, _sc_sending_form_key: form.form_key, _sc_sending_content_revision: String(form.content_revision), _sc_sending_situation_key: a.situation_key, 'Sending situation': s.label };
    Object.entries(PROPERTY_FIELDS).forEach(([k, name]) => { if (a.values[k]) p[name] = a.values[k]; });
    [['sending_point_kind', '_sc_sending_point_kind', 'Sending point'], ['pickup_assistance', '_sc_pickup_assistance', 'Pickup assistance']].forEach(([key, name, label]) => {
      if (!a.values[key]) return;
      p[name] = a.values[key]; p[label] = s.fields.find((f) => f.field_key === key).choices.find((c) => c.choice_key === a.values[key]).label;
    });
    if (a.values.sending_date) p._sc_sending_date_kind = a.values.pickup_assistance === 'requested' ? 'requested_pickup' : 'planned_send';
    return p;
  }
  function bindingFor(form, itemId, sourcePage) {
    return { item_id: itemId, source_page_key: sourcePage, form_key: form.form_key, format_version: 1, content_revision: form.content_revision };
  }
  function decodeDraft(raw, binding, form, now = Date.now()) {
    if (!raw || raw.length > 16000) return null;
    try {
      const d = JSON.parse(raw); exact(d, ['binding', 'updated_at', 'package_key', 'answers']); exact(d.binding, Object.keys(binding));
      check(Object.keys(binding).every((k) => d.binding[k] === binding[k]));
      check(Number.isFinite(d.updated_at) && d.updated_at <= now && now - d.updated_at < TTL);
      validateAnswers(form, d.answers, d.package_key, true);
      return d;
    } catch { return null; }
  }
  class View {
    constructor({ root, form, browser, binding, onChange, onStorageError }) {
      this.root = root; this.form = validateForm(form); this.browser = browser; this.binding = binding;
      this.onChange = onChange; this.onStorageError = onStorageError;
      this.radios = Array.from(root.querySelectorAll('[data-sc-sending-situation]'));
      this.inputs = Array.from(root.querySelectorAll('[data-sc-sending-input]'));
      this.branches = Array.from(root.querySelectorAll('[data-sc-sending-branch]'));
      this.heading = root.querySelector('[data-sc-sending-heading]');
      this.summary = root.querySelector('[data-sc-sending-summary]');
      this.pickupMessage = root.querySelector('[data-sc-sending-pickup-message]');
      this.error = root.querySelector('[data-sc-sending-error]');
      this.disclosure = root.querySelector('[data-sc-sending-disclosure]');
      this.chooser = root.querySelector('[data-sc-sending-chooser]');
      this.selected = root.querySelector('[data-sc-sending-selected]');
      this.selectedLabel = root.querySelector('[data-sc-sending-selected-label]');
      this.changeButton = root.querySelector('[data-sc-sending-change]');
      this.notes = root.querySelector('[data-sc-sending-notes]');
      this.root.addEventListener('click', (event) => {
        if (this.disclosure.open || this.locked || this.failed || event.defaultPrevented) return;
        if (event.target.closest('a, button, input, select, textarea, label')) return;
        this.choosing = true;
        this.render();
        if (event.target.closest('summary')) return;
        this.disclosure.open = true;
        this.disclosure.querySelector('summary').focus();
      });
      this.choosing = false;
      this.changeButton.addEventListener('click', () => {
        if (this.locked || this.failed) return;
        this.disclosure.open = true; this.choosing = true; this.render();
        const radio = this.radios.find((r) => r.checked) || this.radios[0];
        if (radio) radio.focus();
      });
      this.answers = emptyAnswers(); this.packageKey = null; this.updatedAt = null; this.locked = false; this.failed = false;
      this.key = `sc_sending_draft_v1:${binding.item_id}`;
      const raw = browser.sessionStorage.getItem(this.key);
      if (raw !== null) {
        browser.sessionStorage.removeItem(this.key);
        check(browser.sessionStorage.getItem(this.key) === null, 'IDENTITY_STORAGE_UNAVAILABLE');
      }
      this.radios.forEach((r) => {
        const select = () => {
          if (this.locked || this.failed || !this.packageKey) return;
          if (!this.choosing && this.answers.situation_key === r.value) return;
          this.expire();
          const notes = this.answers.values.notes;
          if (this.answers.situation_key !== r.value) this.answers = { situation_key: r.value, values: notes ? { notes } : {} };
          this.choosing = false; this.disclosure.open = true;
          this.edited();
          const next = this.inputs.find((input) => !input.disabled && input.dataset.scSendingInput !== 'notes');
          (next || this.changeButton).focus();
        };
        r.addEventListener('change', select); r.addEventListener('click', select);
      });
      this.inputs.forEach((input) => {
        const listener = () => {
          if (this.locked || this.failed || input.disabled || !this.packageKey) return;
          const key = input.dataset.scSendingInput;
          const value = input.value;
          this.expire();
          if (!this.answers.situation_key) { this.render(); this.onChange(); return; }
          this.answers.values[key] = value;
          this.edited();
        };
        input.addEventListener('input', listener); input.addEventListener('change', listener);
      });
      this.render();
    }
    expire() {
      if (this.updatedAt !== null && Date.now() - this.updatedAt >= TTL) { this.clear(); return true; }
      return false;
    }
    save() {
      try {
        const value = JSON.stringify({ binding: this.binding, updated_at: this.updatedAt, package_key: this.packageKey, answers: this.answers });
        this.browser.sessionStorage.setItem(this.key, value);
        check(this.browser.sessionStorage.getItem(this.key) === value, 'IDENTITY_STORAGE_UNAVAILABLE');
      } catch { this.failed = true; this.locked = true; this.onStorageError(); }
    }
    edited() {
      this.updatedAt = Date.now(); this.error.hidden = true; this.save(); this.render(); this.onChange();
    }
    clear() {
      this.answers = emptyAnswers(); this.updatedAt = null; this.choosing = false; this.disclosure.open = false;
      try { this.browser.sessionStorage.removeItem(this.key); check(this.browser.sessionStorage.getItem(this.key) === null); }
      catch { this.failed = true; this.onStorageError(); }
      this.render();
      return !this.failed;
    }
    setPackage(key, storageType) {
      this.expire(); this.packageKey = key;
      const previousValues = this.answers.values;
      this.answers = compatibleAnswers(this.form, this.answers, key);
      if (Object.keys(previousValues).some((fieldKey) => !Object.hasOwn(this.answers.values, fieldKey))) {
        this.error.hidden = false;
      }
      if (this.updatedAt !== null) this.save();
      this.heading.textContent = storageType === 'sports_gear' ? this.form.heading_sports : this.form.heading_luggage;
      this.root.hidden = false; this.render();
    }
    setLocked(locked) { this.locked = locked || this.failed; this.render(); }
    valid() {
      if (this.failed) return false;
      try { validateAnswers(this.form, this.answers, this.packageKey); return true; } catch { return false; }
    }
    snapshot() {
      this.expire();
      if (this.failed) check(false, 'IDENTITY_STORAGE_UNAVAILABLE');
      try { return properties(this.form, this.answers, this.packageKey); }
      catch (error) { this.disclosure.open = true; this.error.hidden = false; this.error.focus(); throw error; }
    }
    focus() { this.heading.focus(); }
    render() {
      const selected = this.answers.situation_key;
      const showChoice = !selected || this.choosing;
      this.chooser.hidden = !showChoice;
      this.selected.hidden = showChoice;
      this.selectedLabel.textContent = this.form.situations.find((s) => s.situation_key === selected)?.label || '';
      this.changeButton.disabled = this.locked || this.failed;
      this.notes.hidden = showChoice;
      this.summary.hidden = showChoice;
      this.radios.forEach((r) => { r.checked = r.value === selected; r.disabled = this.locked || this.failed; });
      this.branches.forEach((b) => { b.hidden = showChoice || b.dataset.scSendingBranch !== selected; });
      this.root.querySelectorAll('[data-sc-sending-unavailable]').forEach((notice) => { notice.hidden = true; });
      this.inputs.forEach((input) => {
        const key = input.dataset.scSendingInput;
        const active = selected && !showChoice && (input.dataset.scSendingBranchKey === selected || key === 'notes');
        input.disabled = !active || this.locked || this.failed;
        const value = active ? this.answers.values[key] || '' : '';
        if (input.value !== value) input.value = value;
        if (input.options) {
          const s = this.form.situations.find((x) => x.situation_key === selected);
          const f = s && s.fields.find((x) => x.field_key === key);
          Array.from(input.options).forEach((o) => {
            if (!o.value || !f) return;
            const choice = f.choices.find((c) => c.choice_key === o.value);
            o.disabled = !choice || !choice.allowed_package_keys.includes(this.packageKey);
            o.hidden = !choice;
            if (choice) o.textContent = o.disabled && o.dataset.scSendingUnavailableLabel ? o.dataset.scSendingUnavailableLabel : choice.label;
            const notice = this.root.querySelector(`[data-sc-sending-unavailable="${input.dataset.scSendingBranchKey}:${key}:${o.value}"]`);
            if (notice) notice.hidden = !active || !o.disabled;
          });
        }
        const label = this.root.querySelector(`[data-sc-sending-label="${input.dataset.scSendingBranchKey}:${key}"]`);
        if (label && key === 'sending_date') {
          const f = this.form.situations.find((s) => s.situation_key === input.dataset.scSendingBranchKey).fields.find((x) => x.field_key === key);
          label.textContent = this.answers.values.pickup_assistance === 'requested' && f.pickup_label ? f.pickup_label : f.label;
        }
      });
      this.pickupMessage.hidden = showChoice || this.answers.values.pickup_assistance !== 'requested';
      this.summary.textContent = this.valid() ? Object.entries(properties(this.form, this.answers, this.packageKey)).filter(([k]) => !k.startsWith('_')).map(([k, v]) => `${k}: ${v}`).join('\n') : '';
    }
  }
  return { VERSION, TTL, PACKAGES, BRANCHES, LIMITS, FIELD_TYPES, CHOICES, PROPERTY_FIELDS, META_PROPERTIES, ALL_PROPERTIES, validateForm, validateAnswers, compatibleAnswers, emptyAnswers, properties, dateValid, bindingFor, decodeDraft, View };
});
